import { Spin } from 'antd';
import { PictorialBarChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  categories: string[];
  series: Array<{ name: string; data: number[] }>;
}

function PictorialBarWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'pictorial-bar', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <PictorialBarChart categories={data?.categories ?? []} series={data?.series ?? []} />;
}

export const pictorialBarWidgetDef: WidgetDefinition = {
  type: 'pictorial-bar',
  name: 'Pictorial Bar',
  description: 'Icon-based bar chart',
  icon: 'PictureOutlined',
  category: 'chart',
  defaultTitle: 'Pictorial Bar',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: PictorialBarWidget,
  settingsSchema: { fields: [] },
};
